import React, { Component } from 'react'
import Customer from './Customer'
import Shop from './Shop'
import { PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID } from '@constant'
import { Auth } from '@common/Auth'
import { isExperienceStore } from '@util'
@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
export default class extends Component {
  render() {
    if (isExperienceStore()) {
      return <Shop />
    }
    return (
      <>
        <Customer />
        <Shop />
      </>
    )
  }
}
